<style scoped>
.content-wrapper .content {
  padding-top: 95px;
}

.el-select {
  display: block;
}
.el-button--success:focus, .el-button--success:hover{
  background: rgba(200,200,200,2.3);
  border-color:rgba(200,200,200,2.3);
}
.el-button.only-icon {
  background:none; 
}
.el-button.only-icon:hover {
  background:rgb(118, 92, 223); 
  border-color:rgb(118, 92, 223); 
  color: white;
}
.only-icon.danger {
  border-color:#FC8888; 
  color: #FC8888; 
}
.only-icon.danger:hover {
  background:#FC8888;
  border-color:#FC8888;
  color:white;
}
.section-header {
  font-weight: 600;  
  text-transform: capitalize
}
.row {
  margin: 0px auto !important;
  display: flex !important;
}
.row:after, .row:before {
  display:none; 
}
.row:last-child {
  margin-bottom:20px !important;
}
.third-party-container > div {
  padding:0px !important
}
.third-party-container {
  padding:0px 0px;
  display:flex; 
  flex-direction:column
}
.third-party-container .section-header {
  margin:0px; 
}

.third-party-container .title-container {
  margin:0px; 
}
.third-party-container .title-container.with-form {
  margin-bottom:10px;
}
.with-form.not-enabled { 
  margin-bottom:0px !important;
}
.enable-3pv-container {
  width: 100%;
  display:flex; 
  align-items: center;
  justify-content: space-between;
}
.container-disabled {
  pointer-events: none; 
  opacity:0.4;
}

.p-0 {
  padding:0px ;
}
.notIsEnabled {
  pointer-events: none; 
  display:none; 
  opacity: 0.4;
}
.cta-button-container {
  display: flex; 
  justify-content: end;
  margin-top:20px; 
}
.soft-floor-browser.el-input > * {
  text-transform: capitalize !important;
}
.row {
  margin-top:20px;
}
.header-with-info-container {
  display:flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.info-container {
  height:16px; 
  width:16px;
  background: #CDCFD0; 
  display:flex;
  align-items:center;
  justify-content: center;
  border-radius:100%;
}
.info-container > span:before {
  top:1px;
  left:1px;
  font-family:'FontAwesome'; 
  font-size:12px; 
  color:white;
}
.liScriptURL {padding-left:15px;}
.liPubID {padding-right: 15px;}
.add-soft-floor .el-input__inner {
  background:none !important;
}

.cta-button-container {
  margin-top: 60px;
}

.el-button.update {
  color: white;
  background: rgb(118, 92, 223);
}
.el-button.migrate-domain {
  color:rgb(118, 92, 223) ; 
  background:none; 
  border:0px; 
  border-color: none; 
}
.el-button.migrate-domain:hover {
  background:none; 
  border:0px; 
  border-color: none; 
}
.field-label {
  cursor: help
}
</style>
<template>
  <!-- <transition name="el-zoom-in-top"> -->
  <div class="content-wrapper">
    <section class="content">
      <!-- Default box -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Edit Domain</h3>
        </div>
        <div class="box-body">
          <form
            method="post"
            v-on:submit.prevent="() => isManagedInventoryCustomer ? onSubmitManagedService() : onSubmitFlooring()"
            class="form"
            v-loading="loading"
          >
            <span v-show="errors.has('name')" class="help is-danger">{{
              errors.first("name")
            }}</span>
            <div style="padding: 0px 0px;display: flex; flex-direction:column;">
              <div class="row" style="display:flex;width: 100%">
                <div class="col-sm-4" style="display:flex;padding-right:10px;flex-direction:column;align-items:baseline;justify-content:space-between;padding:0px 10px 0px 0px ;">
                  <h5>Publisher</h5>
                  <el-input :value="pubName" style="pointer-events:none">
                  </el-input>
                </div>
                <div class="col-sm-4" style="display:flex;padding-left:10px;flex-direction:column;align-items:baseline;justify-content:space-between;padding:0px 0px 0px 10px;">
                  <h5 class="field-label" title="Is the customer a Floors/Analytics customer or are we managing their inventory?">Site Type</h5> 
                  <el-select v-model="site_type" style="width: 100%" placeholder="Managed Inventory or Flooring">
                    <el-option v-for="type in siteTypeList" :key="type.id" :label="`${type.label}`" :value="type.value">
                    </el-option>
                  </el-select>  
                </div>
                
              </div>
            </div> 
            <hr />
            <h3 style="font-weight:bold;padding:0px 0px 0px 0px;">Site</h3>
            <div style="padding: 0px 0px;display: flex; gap: 20px; flex-direction:column;">
              <div class="row" style="display:flex;gap:20px;width: 100%;">
                <div class="col-sm-3" style="display:flex;align-items:baseline;padding:0px" v-if="isManagedInventoryCustomer">
                  <h5 class="field-label" title="Is the site an SPA? If unsure, please contact the tech team">Single Page Application</h5>
                  <el-switch active-text="" inactive-text="" style="margin-left: 10px;" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isSiteSPA" @change="toggleIsSiteSPA"></el-switch>
                </div>
                <div class="col-sm-3" style="display:flex;align-items:baseline;padding:0px">
                  <h5 class="field-label" title="Is the site an SPA? If unsure, please contact the tech team">Safety Bypass</h5>
                  <el-switch active-text="" inactive-text="" style="margin-left: 10px;" active-color="#765CDF" inactive-color="#CDCFD0" v-model="hasSafetyByPass"></el-switch>
                </div>
                <div class="col-sm-3" style="display:flex;align-items:baseline;padding:0px">
                  <h5 class="field-label" title="Should ads be rendered without Google Ad Manager?">Render Without GAM</h5>
                  <el-switch active-text="" inactive-text="" style="margin-left: 10px;" active-color="#765CDF" inactive-color="#CDCFD0" v-model="renderWithoutGam"></el-switch>
                </div>
                <div class="col-sm-12" style="display:flex;align-items:baseline;padding:0px">
                  <h5 class="field-label" title="Should we use the iframe method to detect ad spots?">AXT Adspot Determination Method</h5>
                  <el-select v-model="AXT_ADSPOT_DETERMINATION_METHOD" style="flex:1;width:100%" placeholder="Select a Detection Method">
                    <el-option value="iframe" label="Iframe"></el-option>
                    <el-option value="default" label="Default"></el-option>
                  </el-select>  
                </div>
                <div class="col-sm-3" style="display:flex;align-items:baseline;padding:0px">
                  <h5 class="field-label" title="Should Mile's prebid analytics adapter be enabled on the site?">Analytics</h5>
                  <el-switch active-text="" inactive-text="" style="margin-left: 10px;" active-color="#765CDF" inactive-color="#CDCFD0" v-model="analytics_enabled"></el-switch>
                </div>
                <div class="col-sm-3" style="display:flex;align-items:baseline;padding:0px" v-if="isManagedInventoryCustomer">
                  <h5 class="field-label" title="Are we expected to load the Amazon Publisher Services tag on the client's site?">Load APS Tag</h5>
                  <el-switch active-text="" inactive-text="" style="margin-left: 10px;" active-color="#765CDF" inactive-color="#CDCFD0" v-model="shouldLoadAPSTag"></el-switch>
                </div>
              </div>
              <div class="row" style="display:flex;gap:20px;row-gap:20px;align-items:end; width: 100%" v-if="isManagedInventoryCustomer">
                <div class="col-sm-4" style="display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;padding:0px;" >
                  <h5 class="field-label" title="Do we use regular Div IDs to identify and target ad spots on the site? Or do we use CSS3 query selectors to identify and target ad spots? If unsure, please contact the tech team">Selector Used in Layouts</h5>
                  <el-select v-model="selectorUsed" style="flex:1;width:100%" placeholder="Selectors">
                    <el-option v-for="selector in selectorUsedList" :key="selector.id" :label="`${selector.label}`" :value="selector.value">
                    </el-option>
                  </el-select>  
                </div>
                <div class="col-sm-4" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px" :class="[isSiteSPA ? 'container-disabled' : '']" >
                  <h5 class="field-label" title="Is there a delay from page load to the insertion of first impression ad spots on the client's site? If yes, please add a delay so that we intentionally delay the detection of the first impression. If unsure, contact the tech team">Delay First Impression Detection</h5>
                  <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="shouldDelayFIDetection"></el-switch>
                </div>
                <div class="col-sm-4" :class="[!shouldDelayFIDetection && !isSiteSPA ? 'container-disabled' : '']" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px;flex-direction:column">
                  <h5 class="field-label" title="How long should the maximum delay be while waiting to detect ad spots for the first impression?">Delay</h5>
                  <el-select v-model="fiDetectionDelaySpeed" style="flex:1; width:100%" placeholder="Select the duration of delay">
                    <el-option v-for="speed in detectionSpeedList" :key="speed.id" :label="`${speed.label}`" :value="speed.value">
                    </el-option>
                  </el-select>  
                </div> 
                <!-- <div class="col-sm-4" style="display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;padding:0px">
                  <h5 style="cursor:help" title="Method used to detect the layout on each page of the site">Layout Detection Method</h5>
                  <el-select v-model="layoutDetectionMethodUsed" style="flex:1;width:100%" placeholder="Select a Detection Method">
                    <el-option v-for="layout in layoutDetectionMethodsList" :key="layout.id" :label="`${layout.label}`" :value="layout.value">
                    </el-option>
                  </el-select>  
                </div> -->
                
              </div>  
              <div class="row" style="display:flex;gap:20px;width: 100%;" v-if="isManagedInventoryCustomer">
                <div class="col-sm-4" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px" v-if="isManagedInventoryCustomer">
                  <h5 class="field-label" title="Should we remove schain from bid requests originating from the client? If unsure, please contact the tech team">Remove Supply Chain for Client Side Bidders?</h5>
                  <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isRemoveSChainEnabled"></el-switch>
                </div>
                <div class="col-sm-4" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px" v-if="isManagedInventoryCustomer">
                </div>
                <div class="col-sm-4" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px" v-if="isManagedInventoryCustomer">
                </div>
              </div>
              <!-- <div class="row" style="display:flex;gap:20px;row-gap:20px; width: 100%;align-items:end" v-if="isManagedInventoryCustomer">
                <div class="col-sm-4" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px">
                  <h5>Delay First Impression Detection</h5>
                  <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="shouldDelayFIDetection"></el-switch>
                </div>
                <div class="col-sm-4" :class="[!shouldDelayFIDetection ? 'container-disabled' : '']" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px;flex-direction:column">
                  <h5 style="cursor:help" title="How long should the maximum delay be while waiting to render the first impression">Speed of Delay</h5>
                  <el-select v-model="detectionSpeed" style="flex:1; width:100%" placeholder="Select a Delay Speed">
                    <el-option v-for="speed in detectionSpeedList" :key="speed.id" :label="`${speed.label}`" :value="speed.value">
                    </el-option>
                  </el-select>  
                </div> 
              </div> -->
            </div>  
            <hr/>
            <h3 style="font-weight:bold;padding:0px 0px 0px 0px;">Floors</h3>
            <div style="display: flex;flex-direction:column">
              <div style="display:flex;gap:20px;width: 100%;">
                <div class="col-md-4" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px">
                  <h5 class="field-label" title="Should Mile floors be enabled on the client's site?">Enabled</h5>
                  <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isFloorsEnabled" @change="toggleFloors"></el-switch>
                </div>
                <div class="col-md-4"  v-if="isFloorsEnabled" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px" :class="[!isFloorsEnabled ? 'container-disabled' : '']">
                  <h5 class="field-label" title="Should we push the rejected bid with the highest CPM from the rejected bids, forcefully, while sending the GAM request for the slot thereby inducing greater competition for the final auction in the ad server?">Push through rejected bids</h5>
                  <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isPushThroughBidEnabled"></el-switch>
                </div>
                <div class="col-md-4"  v-if="isFloorsEnabled" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px" :class="[!isFloorsEnabled ? 'container-disabled' : '']">
                  <h5 class="field-label" title="Should we enable floors only based on an external signal, like a flag being present on the client's site?">Externally signalled floors</h5>
                  <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="externallySignalledFloors"></el-switch>
                </div>
                <div class="col-md-4"  v-if="isFloorsEnabled" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px" :class="[!isFloorsEnabled ? 'container-disabled' : '']">
                  <h5 class="field-label" title="Should floors be split based on session?">Session based split enabled</h5>
                  <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isFloorsSessionBasedSplitEnabled"></el-switch>
                </div>
              </div>
              <div v-if="isFloorsEnabled">
                <hr/> 
                <div class="row third-party-container" style="width:100%" :class="[!isFloorsEnabled ? 'container-disabled' : '']">
                  <div class="col-sm-12 title-container with-form" style="margin-bottom:20px;">
                    <div class="enable-3pv-container">
                      <div class="header-with-info-container">
                        <h4 class="section-header">Soft Floors</h4>
                        <div class="info-container" title="Should Mile floors not be enforced strictly on the client's site?">
                          <span class="fa-info"></span>
                        </div>
                      </div>
                      <el-switch active-color="#765CDF" inactive-color="#CDCFD0" v-model="isSoftFloorsEnabled" @change="toggleSoftFloors"></el-switch>
                    </div>
                  </div>
                  <div style="display:flex;flex-direction:column" v-if="isFloorsEnabled && isSoftFloorsEnabled">
                    <div 
                      v-for="config in softFloorConfig"
                      :key="config.name"
                      class="row col-sm-12 soft-floor-browser" 
                      style="display:flex;gap:0px;align-items:end;justify-content:space-evenly;padding:0px; margin:0px !important"
                    >
                      <div class="col-sm-6" style="display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;padding:0px 10px 0px 0px;">
                        <h5>Browser</h5>
                        <el-input class="soft-floor-browser capitalize" :value="config.name" style="width:100%;pointer-events:none;" >
                        </el-input>
                      </div>
                      <div class="col-sm-6" style="display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;padding:0px 10px 0px 10px;">
                        <h5 style="cursor:help" title="Method used to detect the layout on each page of the site">Percentage of Traffic Applied to</h5>
                        <el-input :value="config.percentage" style="width:100%;pointer-events:none" >
                        </el-input>
                      </div>
                      <div class="add-button" style="padding:0px 0px 0px 10px">
                        <button type="button" @click="() => deleteSoftFloorConfig(config)" class="el-button only-icon danger" style="height:40px;">
                          <i class="el-icon-delete el-icon-left"></i>
                        </button>
                      </div>
                    </div>
                    <div class="row col-sm-12 add-soft-floor" style="display:flex;gap:0px;align-items:end; gap:15px;justify-content:space-evenly;padding:0px 15px 15px 15px; margin:20px 0px 0px 0px !important;background: #F9F7FF; border-radius:4px;">
                    <div class="col-sm-6" style="display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;padding:0px;">
                      <h5 class="field-label" title="Browser soft floors is applied to">Browser</h5>
                      <el-select v-model="softFloorBrowserToAdd" filterable placeholder="Select a Browser" style="width:100%">
                          <el-option v-for="browser in softFloorsBrowserList" :key="browser.id" :label="browser.label" :value="browser.value">
                          </el-option>
                      </el-select>
                    </div>
                    <div class="col-sm-6" style="display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;padding:0px;">
                      <h5 class="field-label" title="Percentage of traffic soft floors is applied to">Percentage of traffic Soft floors is applied to</h5>
                      <el-input v-model="softFloorPercentageToAdd" style="width:100%;background:none !important;">
                      </el-input>
                    </div>
                    <div class="add-button">
                      <button type="button" class="el-button only-icon" style="height:40px;" @click="addSoftFloor">
                        <i class="el-icon-plus el-icon-left"></i>
                      </button>
                    </div>
                  </div> 
                  </div>
                </div>
              </div>
            </div> 
            <div>
              <hr/>
              <h3 style="font-weight:bold;padding:0px 0px 0px 0px;">Prebid.js</h3>
              <div style="padding: 0px 0px;display: flex; flex-direction:column;">
                <div class="row" style="display:flex; gap:20px; width: 100%">
                  <div class="col-sm-4" v-if="isManagedInventoryCustomer" style="padding:0px;display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;">
                    <h5 class="field-label" title="Version of prebid maintained by us on the client's site">Prebid Version</h5>
                    <el-select v-model="selectedPrebidVersion" filterable placeholder="Select a Prebid Version" style="flex:1;width:100%">
                      <el-option v-for="item in prebidVersionsList" :key="item" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="col-sm-4" v-if="isManagedInventoryCustomer" style="padding:0px;display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;">
                    <h5 class="field-label" title="Default timeout for Prebid.js auctions configured on the client's site">Global Auction Timeout (ms)</h5>
                    <el-input :value="auctionTimeout" v-model="auctionTimeout">
                    </el-input>
                  </div>
                  <div class="col-sm-4" v-if="!isManagedInventoryCustomer" style="padding:0px;display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;">
                    <h5 class="field-label" title="Variable name of the global prebid object that handles the auctions on the client's site">Global Prebid Object Name</h5> 
                    <el-input :value="global_prebid_object" v-model="global_prebid_object">
                    </el-input>
                  </div>
                </div>
              </div> 
            </div>
            <div v-if="isManagedInventoryCustomer">
              <hr />
              <h3 style="font-weight:bold;padding:0px 0px 20px 0px;">Google Ad Manager</h3>
              <div style="" >
                <div class="row third-party-container">
                  <div class="col-sm-12 title-container with-form" style="margin-bottom:20px;">
                    <div class="enable-3pv-container">
                      <div class="header-with-info-container">
                        <h4 class="section-header">MCM</h4>
                        <div class="info-container" title="">
                          <span class="fa-info"></span>
                        </div>
                      </div>
                      <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="mcm_enabled" @change="resetMCM"></el-switch>
                    </div>
                  </div>
                  <div style="display:flex; flex-direction:column; gap:20px;"  :class="!mcm_enabled ? `container-disabled`: ``">
                    <div class="row" style="display:flex;gap:20px;width: 100%">
                      <!-- <div class="col-sm-4" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px;flex-direction:column">
                        <h5>DFP Account</h5>
                        <el-select v-model="dfp_credentials" :disabled="!mcm_enabled" filterable placeholder="Select a DFP" style="flex:1;width:100%" @change="filterNetworkList">
                            <el-option v-for="item in dfpAccounts" :key="item.id" :label="item.alias_name" :value="item.id">
                            </el-option>
                        </el-select>
                      </div> -->
                      <div class="col-sm-4" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px;flex-direction:column">
                        <h5 style="cursor:help" title="Method used to detect the layout on each page of the site">Parent DFP Network</h5>
                        <el-select v-model="dfp_network" :disabled="!mcm_enabled"  filterable placeholder="Select a Parent DFP Network" style="flex:1;width:100%;" @change="filterNetworkList">
                            <!-- <el-option key="" label="Select a DFP Network" value=""></el-option> -->
                            <el-option v-for="network in getDfpNetworks(dfp_credentials)" :key="network.id" :label="`${network.network_code +' : ' + network.display_name}`" :value="network.id">
                            </el-option>
                        </el-select>
                      </div>
                      <div class="col-sm-4" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px;flex-direction:column">
                        <h5>MCM Delegation Type</h5>
                        <el-select v-model="account_type" placeholder="Select MCM Delegation Type" style="flex:1;width:100%" :disabled="!mcm_enabled" @change="filterNetworkList">
                          <el-option v-for="(mcm_account_type,id) in mcmAccountType" :data-id="id" :label="{'MANAGE_INVENTORY':'Manage Inventory','MANAGE_ACCOUNT':'Manage Account'}[mcm_account_type.account_type]" :value="mcm_account_type.id" :key="id">
                          </el-option>
                        </el-select>
                      </div>
                      <div class="col-sm-4" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px;flex-direction:column">
                        <h5 style="cursor:help" title="Method used to detect the layout on each page of the site">Child DFP Network</h5>
                        <el-select :disabled="!mcm_enabled" style="flex:1;width:100%" v-model="child_dfp_network" filterable placeholder="Select Child DFP Network">
                          <el-option v-for="network in filteredAccountList" :key="network.id" :label="`${network.child_network_code +' : ' + network.name}`" :value="network.id">
                          </el-option>
                        </el-select>
                      </div>
                    </div> 
                  </div>
                </div>
                <hr/>
                <div class="row third-party-container" :class="mcm_enabled ? `container-disabled`: ``">
                  <div class="col-sm-12 title-container with-form" style="margin-bottom:20px;">
                    <div class="enable-3pv-container">
                      <div class="header-with-info-container">
                        <h4 class="section-header">DFP Network</h4>
                        <div class="info-container" title="">
                          <span class="fa-info"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="display:flex; flex-direction:column; gap:20px;">
                    <div class="row" style="display:flex;gap:0px;width: 100%">
                      <div class="col-sm-4" style="display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;padding:0px;">
                        <h5>Parent DFP Network</h5>
                        <el-select
                          v-model="pubdetailistid"
                          filterable
                          placeholder="Select"
                          style="width:100%"
                          :disabled="mcm_enabled"
                        >
                          <el-option
                            v-for="dfp in dfpNetworkListAsPerSelectedDfpAccount"
                            :key="dfp.id"
                            :label="`${dfp.network_code} : ${dfp.display_name}`"
                            :value="dfp.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div> 
                  </div>
                </div>
                <hr/>
                <div class="row third-party-container">
                  <div class="col-sm-12 title-container with-form" style="margin-bottom:20px;">
                    <div class="enable-3pv-container">
                      <div class="header-with-info-container">
                        <h4 class="section-header">Display</h4>
                        <div class="info-container" title="">
                          <span class="fa-info"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="display:flex; flex-direction:column; gap:20px;">
                    <div class="row" style="display:flex;gap:0px;width: 100%">
                      <div class="col-sm-4" style="display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;padding:0px;">
                        <h5>Parent Ad Unit ID</h5>
                        <el-input
                          placeholder="Parent Ad Unit ID"
                          v-model="parent_ad_unit_id"
                        ></el-input>
                      </div>
                      <div class="col-sm-4" style="display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;padding:0px;padding-left:20px;">
                        <h5>Parent Ad Unit Code</h5>
                        <el-input
                          placeholder="Parent Ad Unit Code"
                          v-model="parent_ad_unit_code"
                        ></el-input>
                      </div>
                    </div> 
                  </div>
                </div>
                <hr/>
                <div class="row third-party-container container-disabled">
                  <div class="col-sm-12 title-container with-form" style="margin-bottom:20px;">
                    <div class="enable-3pv-container">
                      <div class="header-with-info-container">
                        <h4 class="section-header">AMP</h4>
                        <div class="info-container" title="">
                          <span class="fa-info"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="display:flex; flex-direction:column; gap:20px;">
                    <div class="row" style="display:flex;gap:20px;width: 100%">
                      <div class="col-sm-4" style="display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;padding:0px;">
                        <h5>Parent Ad Unit ID</h5>
                        <el-input
                          placeholder="AMP Parent Ad Unit ID"
                          v-model="amp_parent_ad_unit_id"
                        ></el-input>
                      </div>
                      <div class="col-sm-4" style="display:flex;flex-direction:column;align-items:baseline;justify-content:space-between;padding:0px;">
                        <h5>Parent Ad Unit Code</h5>
                        <el-input
                          placeholder="AMP Parent Ad Unit Code"
                          v-model="amp_parent_ad_unit_code"
                        ></el-input>
                      </div>
                    </div> 
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isManagedInventoryCustomer">
              <hr/>
              <h3 style="font-weight:bold;padding:0px 0px 0px 0px;">Privacy</h3>
              <div style="display: flex; gap: 20px;">
                <div style="display:flex;gap:20px;width: 100%;">
                  <div class="col-md-4" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px">
                    <h5 class="field-label" title="Should we add GDPR consent check for Prebid.js on the client's site?">GDPR</h5>
                    <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="gdprConsentRequired"></el-switch>
                  </div>
                  <div class="col-md-4" style="display:flex;align-items:baseline;justify-content:space-between;padding:0px">
                    <h5 class="field-label" title="Should we add CCPA consent check for Prebid.js on the client's site?">CCPA</h5>
                    <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="ccpaConsentRequired"></el-switch>
                  </div>
                </div> 
                
              </div>
            </div>  
            <hr/>
            <h3 style="font-weight:bold;padding:0px 0px 20px 0px;">Third Party Vendors</h3>
            <div style="">
              <div class="row third-party-container">
                <div class="col-md-12 mt-3 title-container with-form" :class="[isWKNDEnabled ? '' : 'not-enabled']">
                  <div class="enable-3pv-container">
                    <h4 class="section-header">WunderKind — Interstitial </h4>
                    <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isWKNDEnabled"></el-switch>
                  </div>
                </div>
                <div class="col-md-4 my-3" v-bind:class="[isWKNDEnabled ? '' : 'notIsEnabled']">
                  <div class="col-md-12 3pv-row p-0">
                    <h5>Site ID</h5>
                    <el-input
                      placeholder="Wunderkind Site ID"
                      v-model="wkndSiteID"
                    ></el-input>
                  </div>
                </div>
              </div>
              <div v-if="isManagedInventoryCustomer">
                <hr/>
                <div class="row third-party-container">
                  <div class="col-md-12 mt-3 title-container with-form" :class="[isIIQEnabled ? '' : 'not-enabled']">
                    <div class="enable-3pv-container">
                      <div class="header-with-info-container">
                        <h4 class="section-header">Intent IQ — User ID </h4>
                        <div class="info-container" title="Intent IIQ is a User ID Vendor. Once enabled, it is only activated on Safari and Firefox browsers in the US and Canada">
                          <span class="fa-info"></span>
                        </div>
                      </div>
                      <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isIIQEnabled"></el-switch>
                    </div>
                  </div>
                  <div class="col-md-12 my-3" v-bind:class="[isIIQEnabled ? '' : 'notIsEnabled']">
                    <div class="col-md-4 3pv-row p-0">
                      <h5>Partner ID</h5>
                      <el-input
                        placeholder="Intent IIQ Partner ID"
                        v-model="iiqPartnerID"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isManagedInventoryCustomer">
                <hr/>
                <div class="row third-party-container">
                  <div class="col-md-12 mt-3 title-container with-form" :class="[isLiveIntentEnabled ? '' : 'not-enabled']">
                    <div class="enable-3pv-container">
                      <div class="header-with-info-container">
                        <h4 class="section-header">Live Intent — User ID</h4>
                      </div>
                      <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isLiveIntentEnabled"></el-switch>
                    </div>
                  </div>
                  <div class="col-md-12 my-3" v-bind:class="[isLiveIntentEnabled ? '' : 'notIsEnabled']">
                    <div class="col-md-4 3pv-row p-0 liPubID">
                      <h5>Publisher ID</h5>
                      <el-input
                        placeholder="Publisher ID"
                        v-model="liPartnerID"
                      ></el-input>
                    </div>
                    <div class="col-md-4 3pv-row p-0 liScriptURL">
                      <h5>Script URL (without protocol)</h5>
                      <el-input
                        placeholder="URL"
                        v-model="liScriptURL"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isManagedInventoryCustomer">
                <hr>
                <div class="row third-party-container">
                  <div class="col-md-12 mt-3 title-container with-form" :class="[isID5Enabled ? '' : 'not-enabled']">
                    <div class="enable-3pv-container">
                      <h4 class="section-header">ID5 — User ID</h4>
                      <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isID5Enabled"></el-switch>
                    </div>
                  </div>
                  <div class="col-md-12 my-3" v-bind:class="[isID5Enabled ? '' : 'notIsEnabled']">
                    <div class="col-md-4 3pv-row p-0">
                      <h5>Partner ID</h5>
                      <el-input
                        placeholder="Partner ID"
                        v-model="id5PartnerID"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isManagedInventoryCustomer">
                <hr>
                <div class="row third-party-container">
                  <div class="col-md-12 mt-3 title-container with-form" :class="[isHadronEnabled ? '' : 'not-enabled']">
                    <div class="enable-3pv-container">
                      <h4 class="section-header">Hadron — User ID </h4>
                      <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isHadronEnabled"></el-switch>
                    </div>
                  </div>
                  <div class="col-md-12 my-3" v-bind:class="[isHadronEnabled ? '' : 'notIsEnabled']">
                      <div class="col-md-4 3pv-row p-0">
                        <h5>Partner ID</h5>
                        <el-input
                          placeholder="Partner ID"
                          v-model="hadronPartnerID"
                        ></el-input>
                      </div>
                    </div>
                </div>
              </div>
              <div v-if="isManagedInventoryCustomer">
                <hr>
                <div class="row third-party-container">
                  <div class="col-md-12 mt-3 title-container with-form" :class="[isLotamIDEnabled ? '' : 'not-enabled']">
                    <div class="enable-3pv-container">
                      <h4 class="section-header">Lotame Pantone — User ID </h4>
                      <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isLotamIDEnabled"></el-switch>
                    </div>

                  </div>
                  <div class="col-md-12 my-3" v-bind:class="[isLotamIDEnabled ? '' : 'notIsEnabled']">
                      <div class="col-md-4 3pv-row p-0">
                        <h5>Client ID</h5>
                        <el-input
                          placeholder="Client ID"
                          v-model="lotameClientID"
                        ></el-input>
                      </div>
                    </div>
                </div>
              </div>
              <div v-if="isManagedInventoryCustomer">
                <hr>
                <div class="row third-party-container">
                  <div class="col-md-12 mt-3 title-container with-form" :class="[isLexiconEnabled ? '' : 'not-enabled']">
                    <div class="enable-3pv-container">
                      <h4 class="section-header">Lexicon — User ID </h4>
                      <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isLexiconEnabled"></el-switch>
                    </div>

                  </div>
                  <div class="col-md-12 my-3" v-bind:class="[isLexiconEnabled ? '' : 'notIsEnabled']">
                      <div class="col-md-4 3pv-row p-0">
                        <h5>Partner ID</h5>
                        <el-input
                          placeholder="Client ID"
                          v-model="lexiconPartnerID"
                        ></el-input>
                      </div>
                    </div>
                </div>
              </div>
              <div>
                <hr>
                <div class="row third-party-container">
                  <div class="col-md-12 mt-3 title-container with-form" :class="[isTTDUnifiedIDEnabled ? '' : 'not-enabled']">
                    <div class="enable-3pv-container">
                      <h4 class="section-header">TTD - UnifiedID — User ID </h4>
                      <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isTTDUnifiedIDEnabled"></el-switch>
                    </div>
                  </div>
                  <div class="col-md-12 my-3" v-bind:class="[isTTDUnifiedIDEnabled ? '' : 'notIsEnabled']">
                      <div class="col-md-4 3pv-row p-0">
                        <h5>Cookie Partner ID</h5>
                        <el-input
                          placeholder="Cookie Partner ID"
                          v-model="ttdCookiePartnerID"
                        ></el-input>
                      </div>
                    </div>
                </div>
              </div>
              <div v-if="isManagedInventoryCustomer">
                <hr>
                <div class="row third-party-container">
                  <div class="col-md-12 mt-3 title-container with-form" :class="[isUID2Enabled ? '' : 'not-enabled']">
                    <div class="enable-3pv-container">
                      <h4 class="section-header">UID2 — User ID </h4>
                      <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isUID2Enabled"></el-switch>
                    </div>

                  </div>
                  <div class="col-md-12 my-3" v-bind:class="[isUID2Enabled ? '' : 'notIsEnabled']">
                      <div class="col-md-4 3pv-row p-0">
                        <h5>UID2 ID Cookie Name</h5>
                        <el-input
                          placeholder="UID2Cookie "
                          v-model="uid2ServerCookie"
                        ></el-input>
                      </div>
                    </div>
                </div>
              </div>
              <div v-if="isManagedInventoryCustomer">
                <hr>
                <div class="row third-party-container">
                  <div class="col-md-12 mt-3 title-container">
                    <div class="enable-3pv-container">
                      <h4 class="section-header">Criteo ID — User ID </h4>
                      <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isCriteoIDEnabled"></el-switch>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isManagedInventoryCustomer">
                <hr>
                <div class="row third-party-container">
                  <div class="col-md-12 mt-3 title-container">
                    <div class="enable-3pv-container">
                      <h4 class="section-header">Shared ID — User ID </h4>
                      <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isSharedIDEnabled"></el-switch>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isManagedInventoryCustomer">
                <hr>
                <div class="row third-party-container">
                  <div class="col-md-12 mt-3 title-container">
                    <div class="enable-3pv-container">
                      <h4 class="section-header">Amx ID — User ID </h4>
                      <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isAmxIDEnabled"></el-switch>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isManagedInventoryCustomer">
                <hr>
                <div class="row third-party-container">
                  <div class="col-md-12 mt-3 title-container">
                    <div class="enable-3pv-container">
                      <h4 class="section-header">Kueez RTB — Performance Enhancing Script</h4>
                      <el-switch active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isKueezPECEnabled"></el-switch>
                    </div>
                  </div>
                </div>
              </div>
            <div class="clearfix cta-button-container">
              <button type="button" style="display:flex; gap:10px;" @click="migrateToMCM" v-if="isManagedInventoryCustomer" class="el-button el-button migrate-domain" :disabled=" account_type === null && child_dfp_network === null">
                <i class="el-icon-upload el-icon-left"></i>
                Migrate Domain
              </button>
              <button 
                class="el-button el-button update" 
                style="display:flex; gap:10px;"
                type="submit"
              >
                <i :class="updatingDomain ? 'el-icon-loading' : 'el-icon-edit' "></i>
                {{
                  updatingDomain ? 'Updating Domain ...' : 'Update Domain'
                }}
              </button>
              
            </div>
          </div>
          </form>
        </div>
      </div>
    </section>
  </div>
  <!-- </transition> -->
</template>
<script>
import axios from "axios";

const siteSettingsStyle = "display:flex;align-items:baseline;justify-content:space-between;padding:0px"
const PREBID_VERSION_KEY = 'prebid_version'

const 
  FLOORING = 'FLOORING', 
  MANAGED_SERVICE = 'MANAGED_SERVICE',
  ID = 'id', 
  QUERY = 'query'

export default {
  data: () => {
    return {
      mcm_enabled:false,
      ad_lightnings_script_tag: "",
      fouanalytics_script_tag: "",
      dfpAccounts: [],
      dfp_credentials: undefined,
      uuid: undefined,
      domId: undefined,
      pubId: undefined,
      pubUid: undefined,
      pubName: undefined,
      name: undefined,
      dfpCredId: undefined,
      child_dfp_network:null,
      dfp_network: undefined,
      childDfpAccounts:[],
      mcmAccountType:[],
      account_type:null,
      pubdetaillist: [],
      pubdetailistid: "",
      pubdetaillistname: "",
      features: null,
      parent_ad_unit_id: undefined,
      parent_ad_unit_code: undefined,
      amp_parent_ad_unit_id: undefined,
      amp_parent_ad_unit_code: undefined,
      dfpNetworkListAsPerSelectedDfpAccount: [],
      assertive_yield_id: undefined,
      ads_txt_prefix: undefined,
      all_prebid_modules: [
        'pubProvidedIdSystem',
        'priceFloors',
        'automatadAnalyticsAdapter',
        'userId',
        'unifiedIdSystem',
        'gdprEnforcement',
        's2sTesting',
        'intentIqIdSystem',
        'sharedIdSystem',
        'amxIdSystem',
        'prebidServerBidAdapter',
        '33acrossIdSystem',
        'uid2IdSystem',
        'gdprEnforcement',
        'enabled'
      ],
      trigger_build: false,
      publishers: [],
      site_type: undefined,
      siteTypeList: [
        {value: FLOORING, label: 'Flooring', id: FLOORING},
        {value: MANAGED_SERVICE, label: 'Managed Inventory Service', id: MANAGED_SERVICE}
      ],
      script_config_features: undefined,
      global_prebid_object: undefined,
      analytics_enabled: undefined,
      floors_enabled: undefined,
      isSecure: true,
      publisherDFP: false,
      infinite_scroll: true,
      seller_json: false,
      gdpr_enabled: false,
      cpra_enabled: false,
      loading: true,
      filteredAccountList:[], 
      isLiveIntentEnabled: false, 
      liPartnerID: undefined, 
      liScriptURL: undefined, 
      isHadronEnabled: undefined, 
      hadronPartnerID: undefined,
      isID5Enabled: undefined, 
      id5PartnerID: undefined, 
      isLexiconEnabled: undefined, 
      lexiconPartnerID: undefined, 
      isTTDUnifiedIDEnabled: undefined,
      ttdCookiePartnerID: undefined,
      isSharedIDEnabled: undefined,
      isAmxIDEnabled: undefined,
      isCriteoIDEnabled: undefined,
      isLotamIDEnabled: undefined, 
      lotameClientID: undefined,
      iiqScriptURL: undefined,
      isIIQEnabled: undefined,
      isWKNDEnabled: undefined,
      AXT_ADSPOT_DETERMINATION_METHOD: undefined,
      isUID2Enabled: undefined,
      uid2ServerCookie: undefined,
      wkndSiteID: undefined,
      isKueezPECEnabled: undefined,
      auctionTimeout: undefined,
      isRemoveSChainEnabled: undefined,
      selectorUsedList: [
        {value: QUERY, label: 'CSS3 Selector', id: QUERY},
        {value: ID, label: 'Div ID', id: ID}
      ],
      selectorUsed: undefined,
      layoutDetectionMethodsList: [
        {value: 'metatag', label: 'Meta Tag', id: 'metatag'},
        {value: 'regex', label: 'URL based Regular Expression', id: 'regex'},
        {value: 'custom', label: 'Custom', id: 'custom'}
      ],
      detectionSpeedList: [
        {value: 10, label: 'Longer', id: 'slow'},
        {value: 6, label: 'Long', id: 'faster'},
        {value: 3, label: 'Short', id: 'fastest'}
      ], 
      detectionSpeed: undefined,
      layoutDetectionMethodUsed: undefined,
      gdprConsentRequired: undefined,
      ccpaConsentRequired: undefined,
      isSiteSPA: undefined,
      hasSafetyByPass: undefined,
      shouldLoadAPSTag: undefined, 
      shouldDelayFIDetection: undefined,
      fiDetectionDelaySpeed: undefined,
      
      softFloorsBrowserList: [
        {value: 'edge', label: 'Edge', id: 'edge'},
        {value: 'google search', label: 'Google Search', id: 'gsc'},
        {value: 'chrome', label: 'Chrome', id: 'chrome'},
        {value: 'safari', label: 'Safari', id: 'safari'}, 
        {value: 'firefox', label: 'Firefox', id: 'firefox'}
      ],
      pubName: undefined,
      isFloorsEnabled: undefined, 
      isPushThroughBidEnabled: undefined, 
      isSoftFloorsEnabled: undefined,
      isFloorsSessionBasedSplitEnabled: undefined, 
      softFloorConfig: [],
      softFloorBrowserToAdd: undefined, 
      softFloorPercentageToAdd: undefined,
      externallySignalledFloors: undefined,
      selectedPrebidVersion: undefined,
      updatingDomain: false,
      renderWithoutGam: false
    };
  },
  created: function () {
    this.uuid = this.$route.params.uuid;
    this.domId = this.$route.params.domId;

    axios
      .all([
        // axios.get(BASE_URL + "v1/publishers/"),
        axios.get(`${BASE_URL}v1/publishers/${this.uuid}/domains/${this.domId}/`),
        axios.get(BASE_URL + "v1/dfp_accounts/"),
        axios.get(BASE_URL + 'v1/child-dfp-network-list/'),
        axios.get(BASE_URL + 'v1/mcm-account-list/'),
        axios.get(BASE_URL + 'v1/domains_features/' + this.domId + '/'),
        axios.get(`${BASE_URL}v1/prebid_module_versions/?limit=1000`)
      ])
      .then(
        axios.spread((pubDetails, dfpaccounts,childAccounts,mcm_type,prebid_features, prebidVersions) => {
          //console.log("dfpaccounts",dfpaccounts.data);
          //console.log("pubdetailslist",pubDetails);
          console.log(pubDetails, dfpaccounts,childAccounts,mcm_type,prebid_features, prebidVersions)

          console.log(prebid_features, "debug message")
          this.site_type = prebid_features.data.hasOwnProperty('site_type') ? prebid_features.data.site_type : MANAGED_SERVICE;

          let configFeatures; 

          try {
            configFeatures = prebid_features.data.hasOwnProperty('script_config_features') ? JSON.parse(prebid_features.data.script_config_features) : {}
          } catch (error) {
            configFeatures = {}
          } 

          this.script_config_features = configFeatures;
          this.analytics_enabled =  configFeatures.analytics;
          this.floors_enabled = configFeatures.floors;
          this.global_prebid_object = configFeatures.GLOBAL_PREBID_OBJECT_NAME || 'pbjs';
          console.log(this.global_prebid_object, configFeatures)

          this.isLiveIntentEnabled = configFeatures.IS_LIVEINTENT_ENABLED || false; 
          this.liPartnerID = configFeatures.LIVE_INTENT_ID || undefined; 
          this.liScriptURL = configFeatures.LIVE_INTENT_SCRIPT_URL || undefined; 
          this.isID5Enabled = configFeatures.ID5_UID_ENABLED || false;
          this.isLexiconEnabled = configFeatures.LEXICON_UID_ENABLED || false; 
          this.isHadronEnabled = configFeatures.HADRON_ID_UID_ENABLED || false;

          this.isIIQEnabled = configFeatures.iiq || false;
          this.iiqPartnerID = configFeatures.iiqPartnerID || ''; 

          this.isTTDUnifiedIDEnabled = configFeatures.IS_TTD_UNIFIEDID_ENABLED || false;
          this.ttdCookiePartnerID = configFeatures.IS_TTD_COOKIE_PARTNER_ID || undefined;

          this.iiqScriptURL = configFeatures.iiqScriptURL || 'https://scripts.atmtd.com/js/iiq.6.061.js';
          this.isSharedIDEnabled = configFeatures.SHARED_ID_UID_ENABLED || false;
          this.isAmxIDEnabled = configFeatures.AMX_ID_UID_ENABLED || false;
          this.isCriteoIDEnabled = configFeatures.CRITEO_ID_UID_ENABLED || false;
          this.isLotamIDEnabled = configFeatures.LOTAME_ID_UID_ENABLED || false;
          this.isWKNDEnabled = configFeatures.wknd || false;
          this.AXT_ADSPOT_DETERMINATION_METHOD = configFeatures.AXT_ADSPOT_DETERMINATION_METHOD;
          this.isUID2Enabled = configFeatures.UID2_UID_ENABLED || false;
          this.wkndSiteID = configFeatures.wkndSiteID || undefined; 
          this.gdprConsentRequired = configFeatures.IS_GDPR_REQUIRED || false; 
          this.ccpaConsentRequired = configFeatures.IS_CCPA_REQUIRED || false;
          this.isSiteSPA = configFeatures.SPA || false; 
          this.hasSafetyByPass = configFeatures.hasSafetyByPass || false; 
          this.renderWithoutGam = configFeatures.RENDER_WITHOUT_GAM || false;
          this.shouldDelayFIDetection = configFeatures.DELAY_FI_DETECTION || false;
          this.shouldLoadAPSTag = configFeatures.DISABLE_APSTAG_INIT ? !(configFeatures.DISABLE_APSTAG_INIT) : true; 
          this.externallySignalledFloors = configFeatures.IS_FLOORS_ENABLED_EXTERNALLY || false; 
          this.isPushThroughBidEnabled = configFeatures.PUSH_THROUGH_REJECTED_BIDS || false;
          this.isFloorsEnabled = configFeatures.floors || false;
          this.isFloorsSessionBasedSplitEnabled = configFeatures.FLOORS_SESSION_BASED_SPLIT_ENABLED || false;

          this.isRemoveSChainEnabled = configFeatures.REMOVE_SCHAIN || false; 

          this.isSoftFloorsEnabled = configFeatures.FLOORS_ENFORCED === false ? true : false
          this.softFloorConfig = configFeatures.ENFORCEMENT_DISABLED_BROWSERS_LIST && this.isSoftFloorsEnabled ? configFeatures.ENFORCEMENT_DISABLED_BROWSERS_LIST : []

          this.auctionTimeout = configFeatures.AUCTION_TIMEOUT || 2000;
          this.selectorUsed = configFeatures.SELECTOR_TYPE || ID;

          this.id5PartnerID = configFeatures.ID5_PARTNER_ID || undefined; 
          this.hadronPartnerID = configFeatures.HADRON_PARTNER_ID || undefined; 
          this.lexiconPartnerID = configFeatures.LEXICON_PARTNER_ID || undefined; 
          this.lotameClientID = configFeatures.LOTAME_PARTNER_ID || undefined;
          this.isKueezPECEnabled = configFeatures.IS_KUEEZ_PEC_ENABLED || false;
          this.uid2ServerCookie = configFeatures.UID2_SERVER_COOKIE || undefined;

          const unsortedPrebidVersionsList = prebidVersions.data.results ? prebidVersions.data.results.map((result) => result.version) : []

          this.prebidVersionsList = unsortedPrebidVersionsList.sort(this.sortSemanticVersions)
          // const useExistingPrebidVersion = prebid_features.data.hasOwnProperty(PREBID_VERSION_KEY) && this.prebidVersionsList.includes(prebid_features.data[`${PREBID_VERSION_KEY}`])
          this.selectedPrebidVersion = prebid_features.data[`${PREBID_VERSION_KEY}`]

          let speedSetAlready, speedToBeUsed; 

          if (configFeatures.MAX_ITERATIONS_AFTER_FIRST_STATIC_DETECTION) {
            speedSetAlready = configFeatures.MAX_ITERATIONS_AFTER_FIRST_STATIC_DETECTION
          } else if (configFeatures.MAX_ITERATIONS_AFTER_FIRST_DYNAMIC_ADDTION) {
            speedSetAlready = configFeatures.MAX_ITERATIONS_AFTER_FIRST_DYNAMIC_ADDTION
          } 

          

          if ([3,6,10].indexOf(speedSetAlready) === -1) {
            if (speedSetAlready > 6) speedToBeUsed = 10; 
            else if (speedSetAlready <= 6 && speedSetAlready > 3) speedToBeUsed = 6; 
            else speedToBeUsed = 3
          } else {
            speedToBeUsed = speedSetAlready
          }

          this.fiDetectionDelaySpeed = speedToBeUsed || 3

          this.pubdetaillist = dfpaccounts.data;
          this.dfpAccounts = this.pubdetaillist;
          this.mcmAccountType = mcm_type.data;
          this.childDfpAccounts = childAccounts.data;

          var selectedDFPAcoountId = pubDetails.data.dfp_credentials.id || 1;

          console.log(pubDetails.data.dfp_credentials, pubDetails.data.dfp_credentials.id)

          if(this.site_type === MANAGED_SERVICE) {
            this.ads_txt_prefix = prebid_features.data.ads_txt_prefix;
            
            this.pubdetailistid = pubDetails.data.dfp_network.id;
            
            
            this.pubName = pubDetails.data.publisher.name

            this.parent_ad_unit_id = pubDetails.data.parent_ad_unit_id;
            this.parent_ad_unit_code = pubDetails.data.parent_ad_unit_code;
            this.amp_parent_ad_unit_id = pubDetails.data.amp_parent_ad_unit_id;
            this.amp_parent_ad_unit_code =
              pubDetails.data.amp_parent_ad_unit_code;
            this.infinite_scroll = pubDetails.data.infinite_scroll;
            this.dfp_network = pubDetails.data.dfp_network.id;
            this.isSecure = pubDetails.data.is_secure;
            this.publisherDFP = pubDetails.data.publishers_dfp;
            this.dfpCredId = pubDetails.data.dfp_credentials;
            this.dfp_credentials = this.dfpCredId ? this.dfpCredId.id : 1
            this.account_type = (pubDetails.data.mcm_enable) ? pubDetails.data.mcm.id:this.account_type
            this.mcm_enabled = pubDetails.data.mcm_enable
            this.child_dfp_network = (pubDetails.data.mcm_enable) ? pubDetails.data.child_dfp_network ? pubDetails.data.child_dfp_network.id : undefined : this.child_dfp_network
            this.features = pubDetails.data.features;
          }

          var selectedAccount = (pubDetails.data.mcm_enable) ? this.mcmAccountType.filter(k=>{return k.id==this.account_type})[0].account_type : ''
          this.filteredAccountList = (pubDetails.data.mcm_enable) ? this.childDfpAccounts.filter(k=>{return (k.delegation_type == selectedAccount && k.dfp_network == this.pubdetailistid)}) : this.childDfpAccounts

          var dp = dfpaccounts.data;

          for (var i = 0; i < dp.length; i++) {
            if (selectedDFPAcoountId == dp[i].id) {
              ////console.log("dfpaccounts +",i ,"=",dp[i]);
              this.dfpNetworkListAsPerSelectedDfpAccount = dp[i].networks;
              break;
            }

            ////console.log("-----------------------------------");
          }

          this.pubId = pubDetails.data.id; //Changing Value
          this.name = pubDetails.data.name;
          this.pubName = pubDetails.data.publisher.name;
          
          
          this.seller_json = pubDetails.data.sellers_json_disabled;
          this.pubUid = pubDetails.data.publisher.id;
          this.initialPubUid = pubDetails.data.publisher.id;

          this.loading = false;
        })
      );
  },
  methods: {
    filterNetworkList(){
          if(this.account_type && this.dfp_network){
            var selectedAccount = this.mcmAccountType.filter(k=>{return k.id==this.account_type})[0].account_type
            this.filteredAccountList = this.childDfpAccounts.filter(k=>{return (k.delegation_type == selectedAccount && k.dfp_network == this.dfp_network)})
            this.child_dfp_network=null
          }
        },
    validateWKND() {
      if (this.isWKNDEnabled && (!this.wkndSiteID || this.wkndSiteID === "")) return false; 
      return true
    },
    isNumber(input) {
      return /^\d+$/.test(input)
    }, 
    validateAuctionTimeout() {
      if (this.auctionTimeout === undefined || this.auctionTimeout === '') return [false, 'Auction Timeout cannot be empty']
      if (!(/^\d+$/.test(this.auctionTimeout || ''))) return [false, 'Auction Timeout has to be a number']
      return [true, undefined]
    },
    onSubmitManagedService() {

      if (this.isLiveIntentEnabled && (this.liScriptURL.indexOf('http://') > -1 || this.liScriptURL.indexOf('https://') > -1)) {
        alert("Live Intent Script URL should not contain the protocol (http/https)")
        return; 
      }

      if (this.isLiveIntentEnabled && (!this.liPartnerID || this.liPartnerID === "")) {
        alert('Live Intent Publisher ID cannot be empty')
        return; 
      }

      if (this.isLiveIntentEnabled && (!this.liScriptURL || this.liScriptURL === "")) {
        alert('Live Intent Script URL cannot be empty')
        return; 
      }

      if (this.isHadronEnabled && (!this.hadronPartnerID || this.hadronPartnerID === "")) {
        alert('Hadron Partner ID cannot be empty')
        return; 
      }

      if (this.isID5Enabled && (!this.id5PartnerID || this.id5PartnerID === "")) {
        alert('ID5 Partner ID cannot be empty')
        return; 
      }

      if (this.isLexiconEnabled && (!this.lexiconPartnerID || this.lexiconPartnerID === "")) {
        alert('Lexicon ID cannot be empty')
        return; 
      }

      if (this.isTTDUnifiedIDEnabled && (!this.ttdCookiePartnerID || this.ttdCookiePartnerID === "")) {
        alert('TTD Cookie Partner ID cannot be empty')
        return; 
      }

      if (this.isLotamIDEnabled && (!this.lotameClientID || this.lotameClientID === "")) {
        alert('Lotame Panoroma client ID cannot be empty')
        return; 
      }

      if (this.isUID2Enabled && (!this.uid2ServerCookie || this.uid2ServerCookie === "")) {
        alert('UID2 ID Cookie Name cannot be empty')
        return; 
      }

      if (this.isIIQEnabled && (!this.iiqPartnerID || this.iiqPartnerID === "")) {
        alert('Intent IQ Partner ID cannot be empty')
        return; 
      }

      if (this.isIIQEnabled &&  !this.isNumber(this.iiqPartnerID)) {
        alert('Intent IQ Partner ID has to be a number')
        return; 
      }

      if (!this.validateWKND()) {
        alert('Wunderkind Site ID cannot be empty')
        return; 
      }

      const [isAuctionTimeoutValid, error] = this.validateAuctionTimeout()

      if (!isAuctionTimeoutValid) {
        alert(error)
        return;
      }
      

      const FEATURES_TO_ADD = {
        ...this.script_config_features,
        analytics: this.analytics_enabled,
        floors: this.isFloorsEnabled,
        AUCTION_TIMEOUT: parseInt(this.auctionTimeout)
      }

      if (this.hasSafetyByPass) {
        FEATURES_TO_ADD.hasSafetyByPass = true;
      } else {
        delete FEATURES_TO_ADD.hasSafetyByPass
      }
      
      if (this.renderWithoutGam) {
        FEATURES_TO_ADD.RENDER_WITHOUT_GAM = true;
      } else {
        delete FEATURES_TO_ADD.RENDER_WITHOUT_GAM
      }
      
      if (this.isSiteSPA) {
        FEATURES_TO_ADD.SPA = true
        FEATURES_TO_ADD.MAX_ITERATIONS_AFTER_FIRST_DYNAMIC_ADDTION = parseInt(this.fiDetectionDelaySpeed)
        FEATURES_TO_ADD.MAX_ITERATIONS_AFTER_FIRST_STATIC_DETECTION = parseInt(this.fiDetectionDelaySpeed)
      } else {
        if (this.shouldDelayFIDetection) {
          FEATURES_TO_ADD.DELAY_FI_DETECTION = true 
          FEATURES_TO_ADD.MAX_ITERATIONS_AFTER_FIRST_DYNAMIC_ADDTION = parseInt(this.fiDetectionDelaySpeed)
          FEATURES_TO_ADD.MAX_ITERATIONS_AFTER_FIRST_STATIC_DETECTION = parseInt(this.fiDetectionDelaySpeed)
        } else {
          if (FEATURES_TO_ADD.DELAY_FI_DETECTION) delete FEATURES_TO_ADD.DELAY_FI_DETECTION
          if (FEATURES_TO_ADD.MAX_ITERATIONS_AFTER_FIRST_STATIC_DETECTION) delete FEATURES_TO_ADD.MAX_ITERATIONS_AFTER_FIRST_STATIC_DETECTION
          if (FEATURES_TO_ADD.MAX_ITERATIONS_AFTER_FIRST_DYNAMIC_ADDTION) delete FEATURES_TO_ADD.MAX_ITERATIONS_AFTER_FIRST_DYNAMIC_ADDTION
        }
      }
      if (!this.shouldLoadAPSTag) FEATURES_TO_ADD.DISABLE_APSTAG_INIT = true
      else {
        if(FEATURES_TO_ADD.DISABLE_APSTAG_INIT) delete FEATURES_TO_ADD.DISABLE_APSTAG_INIT
      }

      if (this.isRemoveSChainEnabled) {
        FEATURES_TO_ADD.REMOVE_SCHAIN = true 
      } else {
        if (FEATURES_TO_ADD.REMOVE_SCHAIN) delete FEATURES_TO_ADD.REMOVE_SCHAIN
      }

      if (this.selectorUsed === QUERY) FEATURES_TO_ADD.SELECTOR_TYPE = QUERY; 
      else FEATURES_TO_ADD.SELECTOR_TYPE = ID

      if (this.isLiveIntentEnabled) {
        FEATURES_TO_ADD.IS_LIVEINTENT_ENABLED = true 
        FEATURES_TO_ADD.LIVE_INTENT_SCRIPT_URL = this.liScriptURL
        FEATURES_TO_ADD.LIVE_INTENT_ID = this.liPartnerID
      } else {
        FEATURES_TO_ADD.IS_LIVEINTENT_ENABLED = false; 
      }

      if (this.isKueezPECEnabled) {
        FEATURES_TO_ADD.IS_KUEEZ_PEC_ENABLED = true;
      }
      else {
        if(FEATURES_TO_ADD.IS_KUEEZ_PEC_ENABLED) delete FEATURES_TO_ADD.IS_KUEEZ_PEC_ENABLED 
      }

      if (this.isSoftFloorsEnabled === true) {
        FEATURES_TO_ADD.FLOORS_ENFORCED = false 
        FEATURES_TO_ADD.ENFORCEMENT_DISABLED_BROWSERS_LIST = this.softFloorConfig
      } else {
        if (FEATURES_TO_ADD.FLOORS_ENFORCED !== undefined) delete FEATURES_TO_ADD.FLOORS_ENFORCED
        if (FEATURES_TO_ADD.ENFORCEMENT_DISABLED_BROWSERS_LIST) delete FEATURES_TO_ADD.ENFORCEMENT_DISABLED_BROWSERS_LIST
      }

      if (this.isID5Enabled) {
        FEATURES_TO_ADD.ID5_UID_ENABLED = true 
        FEATURES_TO_ADD.ID5_PARTNER_ID = this.id5PartnerID
      } else {
        if (FEATURES_TO_ADD.ID5_UID_ENABLED) delete FEATURES_TO_ADD.ID5_UID_ENABLED
        if (FEATURES_TO_ADD.ID5_PARTNER_ID) delete FEATURES_TO_ADD.ID5_PARTNER_ID
      }
      
      if (this.isLexiconEnabled) {
        FEATURES_TO_ADD.LEXICON_UID_ENABLED = true 
        FEATURES_TO_ADD.LEXICON_PARTNER_ID = this.lexiconPartnerID
      } else {
        if (FEATURES_TO_ADD.LEXICON_UID_ENABLED) delete FEATURES_TO_ADD.LEXICON_UID_ENABLED
        if (FEATURES_TO_ADD.LEXICON_PARTNER_ID) delete FEATURES_TO_ADD.LEXICON_PARTNER_ID
      }

      if (this.isTTDUnifiedIDEnabled) {
        FEATURES_TO_ADD.IS_TTD_UNIFIEDID_ENABLED = true 
        FEATURES_TO_ADD.IS_TTD_COOKIE_PARTNER_ID = this.ttdCookiePartnerID
      } else {
        if (FEATURES_TO_ADD.IS_TTD_UNIFIEDID_ENABLED) delete FEATURES_TO_ADD.IS_TTD_UNIFIEDID_ENABLED
        if (FEATURES_TO_ADD.IS_TTD_COOKIE_PARTNER_ID) delete FEATURES_TO_ADD.IS_TTD_COOKIE_PARTNER_ID
      }

      if (this.isLotamIDEnabled) {
        FEATURES_TO_ADD.LOTAME_ID_UID_ENABLED = true 
        FEATURES_TO_ADD.LOTAME_PARTNER_ID = this.lotameClientID
      } else {
        if (FEATURES_TO_ADD.LOTAME_ID_UID_ENABLED) delete FEATURES_TO_ADD.LOTAME_ID_UID_ENABLED
        if (FEATURES_TO_ADD.LOTAME_PARTNER_ID) delete FEATURES_TO_ADD.LOTAME_PARTNER_ID
      }

      if (this.isUID2Enabled) {
        FEATURES_TO_ADD.UID2_UID_ENABLED = true 
        FEATURES_TO_ADD.UID2_SERVER_COOKIE = this.uid2ServerCookie
      } else {
        if (FEATURES_TO_ADD.UID2_UID_ENABLED) delete FEATURES_TO_ADD.UID2_UID_ENABLED
        if (FEATURES_TO_ADD.UID2_SERVER_COOKIE) delete FEATURES_TO_ADD.UID2_SERVER_COOKIE
      }
      
      if (this.isHadronEnabled) {
        FEATURES_TO_ADD.HADRON_ID_UID_ENABLED = true 
        FEATURES_TO_ADD.HADRON_PARTNER_ID = this.hadronPartnerID
      } else {
        if (FEATURES_TO_ADD.HADRON_ID_UID_ENABLED) delete FEATURES_TO_ADD.HADRON_ID_UID_ENABLED
        if (FEATURES_TO_ADD.HADRON_PARTNER_ID) delete FEATURES_TO_ADD.HADRON_PARTNER_ID
      }

      if (this.isIIQEnabled) {
        FEATURES_TO_ADD.iiq = true 
        FEATURES_TO_ADD.iiqPartnerID = parseInt(this.iiqPartnerID)
      } else {
        if (FEATURES_TO_ADD.iiq) delete FEATURES_TO_ADD.iiq
        if (FEATURES_TO_ADD.iiqPartnerID) delete FEATURES_TO_ADD.iiqPartnerID
      }

      if (this.isSharedIDEnabled) FEATURES_TO_ADD.SHARED_ID_UID_ENABLED = true; 
      else {
        if (FEATURES_TO_ADD.SHARED_ID_UID_ENABLED) delete FEATURES_TO_ADD.SHARED_ID_UID_ENABLED; 
      }

      if (this.isAmxIDEnabled) FEATURES_TO_ADD.AMX_ID_UID_ENABLED = true; 
      else {
        if (FEATURES_TO_ADD.AMX_ID_UID_ENABLED) delete FEATURES_TO_ADD.AMX_ID_UID_ENABLED; 
      }

      if (this.isCriteoIDEnabled) FEATURES_TO_ADD.CRITEO_ID_UID_ENABLED = true; 
      else {
        if (FEATURES_TO_ADD.CRITEO_ID_UID_ENABLED) delete FEATURES_TO_ADD.CRITEO_ID_UID_ENABLED; 
      }

      if (this.isWKNDEnabled) {
        FEATURES_TO_ADD.wknd = true; 
        FEATURES_TO_ADD.wkndSiteID = parseInt(this.wkndSiteID); 
      } else {
        if (FEATURES_TO_ADD.wknd) delete FEATURES_TO_ADD.wknd; 
        if (FEATURES_TO_ADD.wkndSiteID) delete FEATURES_TO_ADD.wkndSiteID; 
      }
      if (this.AXT_ADSPOT_DETERMINATION_METHOD) {
        FEATURES_TO_ADD.AXT_ADSPOT_DETERMINATION_METHOD = this.AXT_ADSPOT_DETERMINATION_METHOD;
      } else {
        if (FEATURES_TO_ADD.AXT_ADSPOT_DETERMINATION_METHOD) delete FEATURES_TO_ADD.AXT_ADSPOT_DETERMINATION_METHOD;
      }

      if (this.gdprConsentRequired) FEATURES_TO_ADD.IS_GDPR_REQUIRED = true;
      else if (FEATURES_TO_ADD.IS_GDPR_REQUIRED) delete FEATURES_TO_ADD.IS_GDPR_REQUIRED ; 

      if (this.ccpaConsentRequired) FEATURES_TO_ADD.IS_CCPA_REQUIRED = true;
      else if (FEATURES_TO_ADD.IS_CCPA_REQUIRED) delete FEATURES_TO_ADD.IS_CCPA_REQUIRED
      
      const isMCMEnabled = this.mcm_enabled

      if (isMCMEnabled) {
        console.log(isMCMEnabled, this.dfp_network)
        if (!this.dfp_network || this.dfp_network === '') {
          alert('Parent DFP Network has to be selected'); 
          return; 
        }
        if (!this.account_type) {
          alert('MCM Type has to be selected'); 
          return; 
        }
        if (this.child_dfp_network === undefined || this.child_dfp_network === '') {
          alert('Child DFP Network has to be selected') 
          return; 
        }
      } else {
        if (this.pubdetailistid === "" || !this.pubdetailistid) {
          alert('Parent DFP Network has to be selected')
          return;
        }
      }

      if (
          !this.parent_ad_unit_id || 
          this.parent_ad_unit_id === ''
        ) {
        alert('Parent Ad Unit ID cannot be empty for display inventory')
        return; 
      }

      if (
          !this.parent_ad_unit_code || 
          this.parent_ad_unit_code === ''
        ) {
        alert('Parent Ad Unit Code cannot be empty for display inventory')
        return; 
      }

      if (!this.isNumber(this.parent_ad_unit_id)) {
        alert('Parent Ad Unit ID must be a number for display inventory')
        return;
      }

      let currFeatures = { 
        ...this.features,
        ads_txt_prefix: this.ads_txt_prefix,
        site_type: this.site_type,
        [PREBID_VERSION_KEY]: this.selectedPrebidVersion,
        script_config_features: JSON.stringify(FEATURES_TO_ADD)
      }

      if (process.env.NODE_ENV === 'development') console.log(FEATURES_TO_ADD);

      this.updatingDomain = true
      axios
        .put(
          BASE_URL +
            "v1/publishers/" +
            this.uuid +
            "/domains/" +
            this.domId +
            "/",
          {
            // pub_id: this.pubId,
            fouanalytics_script_tag: this.fouanalytics_script_tag,
            ad_lightnings_script_tag: this.ad_lightnings_script_tag,
            pub_id: this.pubId,
            name: this.name,
            is_secure: this.isSecure,
            publisher: this.pubUid,
            mcm: this.account_type,
            mcm_enable: isMCMEnabled ? true : false,
            child_dfp_network:this.child_dfp_network,
            // publisher: this.publishers,
            publishers_dfp: this.publisherDFP.id,
            parent_ad_unit_id: this.parent_ad_unit_id,
            parent_ad_unit_code: this.parent_ad_unit_code,
            amp_parent_ad_unit_id: this.amp_parent_ad_unit_id,
            amp_parent_ad_unit_code: this.amp_parent_ad_unit_code,
            dfp_credentials: this.dfp_credentials || 1,
            dfp_network:  isMCMEnabled ? this.dfp_network : this.pubdetailistid,
            infinite_scroll: this.infinite_scroll,
            sellers_json_disabled: this.seller_json,
            assertive_yield_id: this.assertive_yield_id,
            features: currFeatures,
            build_module: this.trigger_build,
          }
        )
        .then((response) => {
          this.updatingDomain = false
          this.$notify({
            title: "Success",
            message: "The domain data has been updated.",
            type: "success",
          });
          setTimeout(() => {
            if (this.initialPubUid == this.pubUid) {
              this.$router.push(
                `/admin/publisher/${this.uuid}/domain/edit/${this.domId}/`
              );
            } else {
              this.$router.push("/admin/domains");
            }
          }, 0);
        })
        .catch((error) => {
          this.updatingDomain = false
          this.$notify({
            title: "Error",
            message: "Something went wrong. Please try again later",
            type: "error",
          });
        });

    },
    sortSemanticVersions(a, b) {
  
      // 1. Split the strings into their parts.
      const a1 = a.split('.');
      const b1 = b.split('.');
      // 2. Contingency in case there's a 4th or 5th version
      const len = Math.min(a1.length, b1.length);
      // 3. Look through each version number and compare.
      for (let i = 0; i < len; i++) {
          const a2 = +a1[ i ] || 0;
          const b2 = +b1[ i ] || 0;
          
          if (a2 !== b2) {
              return a2 < b2 ? 1 : -1;        
          }
      }
      
      // 4. We hit this if the all checked versions so far are equal
      //
      return b1.length - a1.length;
    },
    onSubmitFlooring() {
      if (!this.validateWKND()) {
        alert('Wunderkind Site ID cannot be empty')
        return; 
      } 

      if (this.global_prebid_object === undefined || this.global_prebid_object === '') {
        alert('Global Prebid object name cannot be empty'); 
        return;
      }

      const FEATURES_TO_ADD = {
        ...this.script_config_features,
        analytics: this.analytics_enabled,
        floors: this.isFloorsEnabled,
        GLOBAL_PREBID_OBJECT_NAME: this.global_prebid_object, 
      }

      if (this.isFloorsEnabled) {
        FEATURES_TO_ADD.PUSH_THROUGH_REJECTED_BIDS = this.isPushThroughBidEnabled || false
        FEATURES_TO_ADD.IS_FLOORS_ENABLED_EXTERNALLY = this.externallySignalledFloors || false
        FEATURES_TO_ADD.FLOORS_SESSION_BASED_SPLIT_ENABLED = this.isFloorsSessionBasedSplitEnabled || false
      }

      if (this.renderWithoutGam) {
        FEATURES_TO_ADD.RENDER_WITHOUT_GAM = true;
      } else {
        delete FEATURES_TO_ADD.RENDER_WITHOUT_GAM
      }

      if (this.isWKNDEnabled) {
        FEATURES_TO_ADD.wknd = true; 
        FEATURES_TO_ADD.wkndSiteID = parseInt(this.wkndSiteID); 
      } else {
        if (FEATURES_TO_ADD.wknd) delete FEATURES_TO_ADD.wknd
        if (FEATURES_TO_ADD.wkndSiteID) delete FEATURES_TO_ADD.wkndSiteID
      }

      if (this.isSoftFloorsEnabled === true) {
        FEATURES_TO_ADD.FLOORS_ENFORCED = false 
        FEATURES_TO_ADD.ENFORCEMENT_DISABLED_BROWSERS_LIST = this.softFloorConfig
      } else {
        if (FEATURES_TO_ADD.FLOORS_ENFORCED !== undefined) delete FEATURES_TO_ADD.FLOORS_ENFORCED
        if (FEATURES_TO_ADD.ENFORCEMENT_DISABLED_BROWSERS_LIST) delete FEATURES_TO_ADD.ENFORCEMENT_DISABLED_BROWSERS_LIST
      }

      this.updatingDomain = true

      axios
        .put(
          BASE_URL +
            "v1/publishers/" +
            this.uuid +
            "/domains/" +
            this.domId +
            "/",
          {
            pub_id: this.pubId,
            name: this.name,
            is_secure: this.isSecure,
            publisher: this.pubUid,
            mcm:this.account_type,
            mcm_enable: false,
            child_dfp_network: '',
            publishers_dfp: '',
            parent_ad_unit_id: 0,
            parent_ad_unit_code: '',
            amp_parent_ad_unit_id: 0,
            amp_parent_ad_unit_code: '',
            dfp_credentials: 1,
            dfp_network: 1,
            infinite_scroll: false,
            sellers_json_disabled: false,
            features: {
              site_type: this.site_type,
              script_config_features: JSON.stringify(FEATURES_TO_ADD)
            },
          }
        )
        .then((response) => {
          this.updatingDomain = false
          this.$notify({
            title: "Success",
            message: "The domain data has been updated",
            type: "success",
          });
          setTimeout(() => {
            if (this.initialPubUid == this.pubUid) {
              this.$router.push(
                `/admin/publisher/${this.uuid}/domain/edit/${this.domId}/`
              );
            } else {
              this.$router.push("/admin/domains");
            }
          }, 0);
        })
        .catch((error) => {
          this.updatingDomain = false
          this.$notify({
            title: "Error",
            message: "There was an error, please try again later",
            type: "error",
          });
        });
    }, 
    toggleFloors() {
      if (!this.isFloorsEnabled) {
        this.softFloorConfig = []
        this.isSoftFloorsEnabled = false
      }
    },
    toggleSoftFloors() {
      if (!this.isSoftFloorsEnabled) this.softFloorConfig = []
    },
    addSoftFloor() {
      if (this.softFloorBrowserToAdd === undefined) {
        alert('Add a valid browser for soft floors'); 
        return; 
      }
      
      if (this.softFloorPercentageToAdd === undefined || !(/^\d+$/.test(this.softFloorPercentageToAdd || ''))) {
        alert('Add a valid percentage for soft floors');
        return; 
      }
      
      
      
      const percentage = parseInt(this.softFloorPercentageToAdd)

      if (percentage > 100) {
        alert('Only <= 100 percent of traffic can be soft floored');
        return;
      }

      const doesSoftFloorExistForBrowser = this.softFloorConfig.filter(({browser}) => browser === this.softFloorBrowserToAdd)
      
      if (doesSoftFloorExistForBrowser.length) {
        alert(`Soft floors has already been enabled for ${this.softFloorBrowserToAdd}`)
        return; 
      }

      this.softFloorConfig.push({
        name: this.softFloorBrowserToAdd, 
        percentage: parseInt(this.softFloorPercentageToAdd)
      })
      this.softFloorBrowserToAdd = undefined
      this.softFloorPercentageToAdd = undefined
    }, 
    linkDFP() {
      axios
        .get(
          BASE_URL +
            "v1/publishers/" +
            this.uuid +
            "/domains/" +
            this.domId +
            "/get_dfp_auth_link/"
        )
        .then((response) => {
          window.location = response.data.authorization_url;
        })
        .catch((error) => {
          //////console.log(error);
        });
    },
    getDfpNetworks(dfp_credentials_id) {
            // //console.log(dfp_credentials_id);
            // //console.log(this.dfpAccounts);
            if (dfp_credentials_id) {
                for (let i = 0; i < this.dfpAccounts.length; i++) {
                    if (dfp_credentials_id == this.dfpAccounts[i].id) {
                        //console.log(this.dfpAccounts[i].networks);
                        let dfp_networks = [];
                        for (let j = 0; j < this.dfpAccounts[i].networks.length; j++) {
                            //console.log(this.dfpAccounts[i].networks[j]);
                            if (this.dfpAccounts[i].networks[j].hb_setup_done) dfp_networks.push(this.dfpAccounts[i].networks[j]);
                        }
                        //console.log(dfp_networks);
                        return dfp_networks;
                    }
                }
            } else {
                return [];
            }
      },
    migrateToMCM(){
      var selectedAccount = this.mcmAccountType.filter(k=>{return k.id==this.account_type})[0].account_type
      var targetDfp = (selectedAccount=='MANAGE_ACCOUNT')?this.child_dfp_network:this.pubdetailistid
      axios
        .put(
          BASE_URL +
            "v1/publishers/" +
            this.uuid +
            "/domains/" +
            this.domId +
            "/",
          {
            // pub_id: this.pubId,
            fouanalytics_script_tag: this.fouanalytics_script_tag,
            ad_lightnings_script_tag: this.ad_lightnings_script_tag,
            pub_id: this.pubId,
            name: this.name,
            is_secure: this.isSecure,
            publisher: this.pubUid,
            mcm: this.account_type,
            mcm_enable:( this.account_type!=null)?true:false,
            child_dfp_network:this.child_dfp_network,
            // publisher: this.publishers,
            publishers_dfp: this.publisherDFP.id,
            parent_ad_unit_id: this.parent_ad_unit_id,
            parent_ad_unit_code: this.parent_ad_unit_code,
            amp_parent_ad_unit_id: this.amp_parent_ad_unit_id,
            amp_parent_ad_unit_code: this.amp_parent_ad_unit_code,
            dfp_credentials: this.dfp_credentials,
            dfp_network: (this.account_type!=null) ? this.dfp_network : this.pubdetailistid,
            infinite_scroll: this.infinite_scroll,
            sellers_json_disabled: this.seller_json,
          }
        )
        .then((response) => {
      axios
        .post(
          BASE_URL +
            "v1/mcm-migration/domain/" +
            this.domId +
            "/dfp-network/"+targetDfp,
          {}
        ).then((response) => {
          this.$notify({
            title: "Success",
            message: "Domain Migration Initiated",
            type: "success",
          });
          setTimeout(() => {
            if (this.initialPubUid == this.pubUid) {
              this.$router.push(
                `/admin/publisher/${this.uuid}/domain/edit/${this.domId}/`
              );
            } else {
              this.$router.push("/admin/domains");
            }
          }, 1000);
        })
        .catch((error) => {
          this.$notify({
            title: "Warning",
            message: "Something went wrong. Try again in sometime",
            type: "warning",
          });
        });
        }).catch((error) => {
          this.$notify({
            title: "Warning",
            message: "Something went wrong. Try again in sometime",
            type: "warning",
          });
        });
    },
    updateDomain() {},
    toggleIsSiteSPA() {
      this.shouldDelayFIDetection = this.isSiteSPA
    },
    resetMCM(){
      if (this.mcm_enabled) {
        this.pubdetailistid = ""
      } else {
        this.dfp_credentials = this.dfpCredId.id
        this.dfp_network = this.pubdetailistid
        this.account_type = null
        this.child_dfp_network = null
      }
       
      },
      deleteSoftFloorConfig(config) {
        const updatedList = this.softFloorConfig.filter(({name}) => {
          return name !== config.name ? true : false
        })

        this.softFloorConfig = [...updatedList]
      }
  },
  computed: {
    _get_user() {
      // return this.$auth.user() || {};
      let token = window.localStorage && localStorage["default_auth_token"];
      if (token) {
        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );

        return JSON.parse(jsonPayload);
      } else return undefined;
    },
    hasAccess() {
      return [3, 8, 41, 155, 310].includes(
        this._get_user && this._get_user.user_id
      );
    },
    isFlooringCustomer() {
      return this.site_type === FLOORING
    },
    isManagedInventoryCustomer() {
      return this.site_type === MANAGED_SERVICE
    }
  },
};
</script>



// WEBPACK FOOTER //
// EditDomain.vue?dba4952a